import Swal from "sweetalert2";
import axiosApi from "../axiosInstance";

const getassetSpecList = async () => {
  try {
    const response = await axiosApi.get(
      `/AssetSpecification/GetAllAssetSpecification`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getLocationList===>:", error);
    return error?.response?.data;
  }
};

const addAssetspec = async (body) => {
  try {
    const response = await axiosApi.post(
      `AssetSpecification/createAssetSpecification`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error addLocation ===>", error);
    return error?.response?.data;
  }
};

const getSpecId = async (catId, subCatId) => {
  try {
    const response = await axiosApi.get(
      `/AssetSpecification/GetSpecificationId/` + catId + "/" + subCatId
    );

    return response?.data;
  } catch (error) {
    console.log("Error getLocationList===>:", error);
    return error?.response?.data;
  }
};
const getSpecsub = async (Id) => {
  try {
    const response = await axiosApi.get(
      `/AssetSpecification/getAllSpecificationSub/` + Id
    );

    return response?.data;
  } catch (error) {
    console.log("Error getLocationList===>:", error);
    return error?.response?.data;
  }
};
const getSpecsublist = async (categoryId, subcategoryid, assetId) => {
  try {
    const response = await axiosApi.get(
      `/AssetSpecification/getSpecificationSub/` +
        categoryId +
        "/" +
        subcategoryid +
        "/" +
        assetId
    );
    return response?.data;
  } catch (error) {
    console.log("Error getLocationList===>:", error);
    return error?.response?.data;
  }
};

export const assetSpecService = {
  getassetSpecList,
  addAssetspec,
  getSpecsub,
  getSpecsublist,
  getSpecId,
};
